import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=7bd24aba&scoped=true"
import script from "./detail.vue?vue&type=script&lang=jsx"
export * from "./detail.vue?vue&type=script&lang=jsx"
import style0 from "./detail.vue?vue&type=style&index=0&id=7bd24aba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd24aba",
  null
  
)

export default component.exports